import useBreakpoints from '@hooks/useBreakpoints';
import useTheme from '@hooks/useTheme';

const useStyles = () => {
  const { isMobile } = useBreakpoints();
  const theme = useTheme();
  const { font } = theme;
  return {
    container: {
      padding: !isMobile ? '16px 24px 8px 24px' : '8px 16px',
      display: 'flex',
      alignItems: 'center'
    },
    notificationTitle: {
      color: font.color.base,
      flex: 1,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      marginTop: 0,
      marginBottom: 0
    },
    settingsTitle: {
      fontSize: font.base.size.h3,
      color: font.color.base,
      flex: 1,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textAlign: 'center',
      textOverflow: 'ellipsis',
      marginTop: 0,
      marginBottom: 0
    },
    close: {
      marginLeft: 10,
      backgroundColor: 'transparent',
      color: font.color.base,
      border: 'none'
    },
    back: {
      backgroundColor: 'transparent',
      border: 'none'
    },
    actionButton: {
      backgroundColor: 'transparent',
      color: font.color.base,
      border: 'none',
      cursor: 'pointer'
    }
  };
};
export default useStyles;
